import React from 'react';
import PropTypes from 'prop-types';

const TabNavigation = ({ activeTab, setActiveTab }) => {
    const tabs = [
        { id: 'overview', label: 'Overview' },
        { id: 'business', label: 'Business Content' },
        { id: 'design', label: 'Design & Colors' },
        { id: 'media', label: 'Media & Images' }
    ];

    return (
        <div className="tab-navigation">
            {tabs.map(tab => (
                <button
                    key={tab.id}
                    className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

TabNavigation.propTypes = {
    activeTab: PropTypes.string.isRequired,
    setActiveTab: PropTypes.func.isRequired
};

export default TabNavigation;
